import NextSectionAction from "components/next-section-action";
import dynamic from "next/dynamic";

import { DemoSchemes } from "../../components/demo-form-section";
import Page from "../../components/layout/page";
import MainHero from "../../components/views/customer-engagement/main-hero";

const DemoFormSection = dynamic(() => import("../../components/demo-form-section"));
const TheProcess = dynamic(() => import("../../components/views/customer-engagement/the-process"));

import type { NextPage } from "next";
const CustomerEngagement: NextPage = () => (
  <Page
    title="Enerflo Solar Software Platform Features | Customer Portal"
    description="Build trust by keeping your customers engaged and informed throughout the solar sales and fulfillment process with the Enerflo Customer Portal."
  >
    <MainHero />
    <TheProcess />
    <NextSectionAction
      buttonText="View Docflo"
      url="/features/docflo"
      description="Generate Customer Signing Packets in 3 Seconds"
    />
    <DemoFormSection scheme={DemoSchemes.LIGHT} />
  </Page>
);

export default CustomerEngagement;
